"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.MutationForbidden = exports.MutationRejected = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const ExistenceCheck = __importStar(require("./existence-check"));
const UserSchema = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.User.Spec';
const Role = User.GlobalUserRole.enums;
const withReadGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandSupportOperator, Role.BrandTechOperator, Role.Dealer, Role.DealerTechnician);
const withDealerGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.Dealer);
const withTechnicalGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandTechOperator, Role.Dealer);
const ProfilePageResponse = openapi_1.Response.Success(UserSchema.ProfilePage).annotations({
    description: 'Paginated user profiles',
});
const ProfileResponse = openapi_1.Response.Success(UserSchema.Profile).annotations({
    description: 'User profile',
});
const EmailHistoryResponse = openapi_1.Response.Success(UserSchema.EmailHistory).annotations({
    description: 'SendGrid message activity for the email address',
});
const ExistenceCheckResponse = openapi_1.Response.Success(ExistenceCheck.Response).annotations({
    description: 'Whether the email belongs to a user in the caller tenant scope',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful user-account mutation',
});
// Role, tenant and self-delete checks run after express-validator and send the error object itself.
exports.MutationRejected = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.MutationRejected`, 'INVALID_REQUEST', 'Mutation Rejected', 'A role, tenant or self-delete check rejected a request that passed field validation. inputValidation is the serialized error object, not a list of express-validator field errors.', { inputValidation: Json.Record });
// Same checks as MutationRejected: a forbidden role or tenant is a 403 that still sends the error object.
exports.MutationForbidden = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('NOT_ALLOWED'),
        inputValidation: Json.Record,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.MutationForbidden`,
    title: 'Mutation Forbidden',
    description: 'A role or tenant check rejected a request that passed field validation. Unlike V1Forbidden, the body carries inputValidation with the serialized error object.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 403,
});
const TenantFilterRejected = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.TenantFilterRejected`, 'INVALID_REQUEST', 'Tenant Filter Rejected', 'The tenant scope for the search could not be resolved. Carries no express-validator field errors.');
const listUsers = platform_1.HttpApiEndpoint.get('listUsers') `/list`
    .setUrlParams(UserSchema.ListUsersQuery)
    .addSuccess(ProfilePageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Users')
    .annotate(platform_1.OpenApi.Description, 'Lists user profiles visible to the caller, with pagination. sysAdmin/admin see all users; dealer sees only own; other roles currently see all users.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const searchUsers = platform_1.HttpApiEndpoint.get('searchUsers') `/search`
    .setUrlParams(UserSchema.SearchUsersQuery)
    .addSuccess(ProfilePageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(TenantFilterRejected)
    .annotate(platform_1.OpenApi.Title, 'Search Users')
    .annotate(platform_1.OpenApi.Description, "Searches user profiles by identity, tenant, dealer, role and account fields. Results are limited to the caller's tenant subtree; callers on the root tenant or without a tenant see every tenant. A tenantId outside that subtree, or any tenantId from a caller without a tenant, returns 403 NOT_ALLOWED.")
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const getAccount = platform_1.HttpApiEndpoint.get('getAccount') `/account`
    .setUrlParams(UserSchema.AccountQuery)
    .addSuccess(ProfileResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get User Account')
    .annotate(platform_1.OpenApi.Description, 'Returns one user profile by userId within the caller scope. 404 when the user does not exist or is outside the caller scope.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const createAccount = platform_1.HttpApiEndpoint.post('createAccount') `/account`
    .setPayload(UserSchema.CreateAccountPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.MutationRejected)
    .addError(exports.MutationForbidden)
    .annotate(platform_1.OpenApi.Title, 'Create User Account')
    .annotate(platform_1.OpenApi.Description, 'Creates a user account, generates a reset-password invitation and sends the invitation email. Returns 200 with empty data (no user id). If sending the invitation fails the API returns 500 although the account is already created. 422 also covers EMAIL_EXISTS.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
const updateAccount = platform_1.HttpApiEndpoint.put('updateAccount') `/account`
    .setPayload(UserSchema.UpdateAccountPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(exports.MutationRejected)
    .addError(exports.MutationForbidden)
    .annotate(platform_1.OpenApi.Title, 'Replace User Account')
    .annotate(platform_1.OpenApi.Description, 'Replaces the user profile. Omitted optional fields are cleared to null (including tenantId, dealerIds, accountNumber and mobilePhoneNumber); omitted firstName, lastName and country are kept. Empty strings are stored as null. When roles is provided it replaces globalRoles, and user is always added. Returns 200 even if the identity provider is updated but saving the stored profile fails.')
    .pipe(withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const patchAccount = platform_1.HttpApiEndpoint.patch('patchAccount') `/account`
    .setPayload(UserSchema.UpdateAccountPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(exports.MutationRejected)
    .addError(exports.MutationForbidden)
    .annotate(platform_1.OpenApi.Title, 'Patch User Account')
    .annotate(platform_1.OpenApi.Description, 'Updates only the supplied fields; omitted fields are kept. Empty strings are stored as null, including firstName, lastName and country. When roles is provided it replaces globalRoles, and user is always added. Returns 200 even if the identity provider is updated but saving the stored profile fails.')
    .pipe(withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const deleteAccount = platform_1.HttpApiEndpoint.del('deleteAccount') `/account`
    .setPayload(UserSchema.DeleteAccountPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(exports.MutationRejected)
    .addError(exports.MutationForbidden)
    .annotate(platform_1.OpenApi.Title, 'Delete User Account')
    .annotate(platform_1.OpenApi.Description, 'Deletes the user from the identity provider and the database, and removes their device registrations, app configurations and notifications. Deleting yourself is rejected with 422. Returns 200 even if removing devices, app configurations or notifications fails.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
const getEmailHistory = platform_1.HttpApiEndpoint.get('getEmailHistory') `/email/history`
    .setUrlParams(UserSchema.EmailQuery)
    .addSuccess(EmailHistoryResponse)
    .annotate(platform_1.OpenApi.Title, 'Get User Email History')
    .annotate(platform_1.OpenApi.Description, 'Returns up to 50 SendGrid message activity records for an email address. The first space in email is turned back into +, so an unencoded + works only once. Not scoped by caller: any read role can see any address. A missing email currently returns 500 instead of 422.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const checkExistence = platform_1.HttpApiEndpoint.get('checkExistence') `/existence-check`
    .setUrlParams(UserSchema.EmailQuery)
    .addSuccess(ExistenceCheckResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Check User Existence')
    .annotate(platform_1.OpenApi.Description, 'Checks whether an email belongs to a user in the current tenant scope. Email is normalized. Returns 403 NOT_ALLOWED when the caller has no tenantId (business rule, separate from the route guard).')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.user')
    .add(listUsers)
    .add(searchUsers)
    .add(getAccount)
    .add(createAccount)
    .add(updateAccount)
    .add(patchAccount)
    .add(deleteAccount)
    .add(getEmailHistory)
    .add(checkExistence)
    .prefix('/admin/user')
    .annotate(platform_1.OpenApi.Title, 'Users')
    .annotate(platform_1.OpenApi.Description, 'Admin user-account endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map